import { BRAND, IMAGES, waLink } from "@/lib/site";
import { Instagram, MessageCircle, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A0A0A] text-white pt-20 pb-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-6">
            <p className="text-[11px] tracking-[0.3em] uppercase text-neutral-400 mb-6">
              Beauty Studio · Porto
            </p>
            <h3 className="font-serif font-light text-3xl md:text-4xl leading-tight max-w-md">
              Realçar a sua beleza, com elegância e <em className="italic">delicadeza.</em>
            </h3>
            <div className="mt-10 flex flex-wrap gap-3">
              <a
                href={waLink()}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp"
                className="inline-flex items-center gap-2 bg-white text-black px-6 py-3 text-[11px] tracking-[0.3em] uppercase hover:bg-neutral-200 transition-colors"
              >
                <MessageCircle className="h-4 w-4" />
                WhatsApp
              </a>
              <a
                href={BRAND.instagramUrl}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                className="inline-flex items-center gap-2 border border-white/40 text-white px-6 py-3 text-[11px] tracking-[0.3em] uppercase hover:border-white transition-colors"
              >
                <Instagram className="h-4 w-4" />
                @{BRAND.instagram}
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-400 mb-4">
              Estúdio
            </div>
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(BRAND.address.full)}`}
              target="_blank"
              rel="noreferrer"
              className="text-white text-sm leading-relaxed link-underline inline-flex items-start gap-2"
            >
              <MapPin className="h-4 w-4 mt-0.5" />
              <span>
                {BRAND.address.street}
                <br />
                {BRAND.address.detail}
                <br />
                {BRAND.address.city}
              </span>
            </a>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-400 mb-4">
              Navegação
            </div>
            <ul className="space-y-3 text-sm">
              {[
                ["sobre", "Sobre"],
                ["procedimentos", "Procedimentos"],
                ["espaco", "Espaço"],
                ["localizacao", "Localização"],
              ].map(([id, label]) => (
                <li key={id}>
                  <a href={`#${id}`} className="link-underline text-neutral-300 hover:text-white">
                    {label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href={BRAND.bookingUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="link-underline text-neutral-300 hover:text-white"
                >
                  Agendar
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="relative -mx-6 md:-mx-12 border-t border-white/10 pt-10">
          <div
            className="mx-6 md:mx-12 mb-10 relative overflow-hidden border-y border-white/10"
            data-testid="footer-banner"
          >
            <img
              src={IMAGES.footerBanner}
              alt="Sena Beauty · olhar"
              loading="lazy"
              className="block w-full h-[180px] md:h-[280px] object-cover"
            />
          </div>
          <div className="px-6 md:px-12 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <div className="font-bebas text-[12vw] md:text-[10vw] lg:text-[8rem] leading-[0.9] tracking-[0.03em] text-white select-none uppercase">
              Sena Beauty
            </div>
          </div>
          <div className="px-6 md:px-12 mt-10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-neutral-500">
            <span>© {new Date().getFullYear()} Sena Beauty Studio. Todos os direitos reservados.</span>
            <span className="tracking-[0.25em] uppercase">Porto · Portugal</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
